import { render, staticRenderFns } from "./authorizedPersonsPage.vue?vue&type=template&id=7a8aa90e&scoped=true"
import script from "./authorizedPersonsPage.vue?vue&type=script&lang=js"
export * from "./authorizedPersonsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8aa90e",
  null
  
)

export default component.exports